var cloud = require('cloud/base/cloud');
var Header = require("./common/header");
var Nav = require("./common/nav");
var Footer = require("./common/footer");
var validator = require("cloud/components/validator");
require('./resources/css/common.css');
require('./resources/css/home.css');
require('./resources/css/verifyBrowser.css');
require('bootstrap/dist/css/bootstrap.css');
require('cloud/components/email-autocomplete');
require('cloud/resources/css/email-autocomplete.css');
var locale = require('cloud/base/locale');
var dialog = require('cloud/components/dialog');
var Content = require('./content.html');
var qrcode = require("qrcode-npm/qrcode");

var Captcha = require("cloud/components/captcha");

/**
 * 判断是否为IE9以下浏览器
 * flag为false时，浏览器为为IE9或IE10
 */
var flag = function () {
  var bua = navigator.userAgent;
  var reg = new RegExp("MSIE ([5,6,7,8][/.0-9]{0,})");
  return !reg.exec(bua);
}();


var validateEmail = function (email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

$(function () {
  $('body').show();
  if (!flag) {//浏览器为为IE9以下时做如下操作
    $("<div id='tip_top' class='tip_top'></div>")
      .appendTo("body")
      .css({
        "height": (document.documentElement.clientHeight / 2),
        "width": document.documentElement.clientWidth,
        "top": -(document.documentElement.clientHeight / 2)
      }).animate({top: "0px"}, 300, function () {
      $("<div id='tip_content' class='tip_content'></div>").html("<div class='text_div_1'><image class='inhand_logo' src='./resources/images/Logo-InHand.png' />" +
        "<p class='text_title'>浏览器不受支持</p>" +
        "<p class='text_content'>使用当前浏览器，无法获得最佳体验，建议使用最新的" +
        "<a class='browser_link' href='http://www.firefox.com.cn'>Firefox</a>或" +
        "<a class='browser_link' href='http://www.google.cn/intl/zh-CN/chrome/browser/'>Chrome</a>浏览器</p></div>" +
        "<div class='text_div_2'>" +
        "<p class='text_title'>Browser Tip</p>" +
        "<p class='text_content'>Suggest to select the latest version of " +
        "<a class='browser_link' href='http://www.mozilla.org/en-US/firefox/new/'>Firefox</a> or " +
        "<a class='browser_link' href='https://www.google.com/intl/en/chrome/browser/'>Chrome</a> browser</p></div>"
      ).appendTo("body").css({
        "top": ((document.documentElement.clientHeight / 2) - 125) + "px",
        "left": ((document.documentElement.clientWidth / 2) - 225) + "px"
      });
      $("<div class='ignore_button'></div>").appendTo($("#tip_content")).text("Skip").mouseover(function () {
        $(this).css({
          "cursor": "pointer",
          "font-weight": "bold"
        })
          .mousedown(function () {
            $(this).css({
              "border-right": "2px solid #dddddd",
              "border-bottom": "2px solid #dddddd"
            })
          })
          .mouseout(function () {
            $(this).css({
              "border-right": "2px solid #7E807C",
              "border-bottom": "2px solid #7E807C",
              "font-weight": "normal"
            })
          })
      }).click(function () {
        $("#tip_bottom").animate({top: (document.documentElement.clientHeight) + "px"}, 300, function () {
          $(this).remove()
        });
        $("#tip_top").animate({top: -(document.documentElement.clientHeight / 2) + "px"}, 300, function () {
          $(this).remove()
        });
        $("#tip_content").fadeOut(300, function () {
          $(this).remove()
        });
      })
    });
    $("<div id='tip_bottom' class='tip_bottom'></div>").appendTo("body").css({
      "height": (document.documentElement.clientHeight / 2),
      "width": document.documentElement.clientWidth,
      "top": document.documentElement.clientHeight
    }).animate({top: (document.documentElement.clientHeight / 2) + "px"}, 300)
  }

  new Index();
});

var Index = Class.create(cloud.Component, {
  loginType: 'password',
  initialize: function ($super, options) {
//            $super(options);
    var self = this;
    this.header = null;
    this.navigate = null;
    this.footer = null;
    this._render();
    $("#home-input-user").focus();
  },

  _render: function () {
    var self = this;
    $('#content').html(Content);
    this._renderHeader();
    this._renderNav();
    this._renderFooter();
    this._effects();
    this._events();
    this._validator();
    this._locale();
    this._setAboutUsLink();
    this._renderQRcode();
    this._emailAutoComplete();
    this._getMobileCode();

    this.loginCaptcha = new Captcha({selector: $(".login-captcha")});

    $("#home-input-pwd-password").focus(
      function () {
        if ($(this).attr("type") == "text") {
          $(this)[0].type = "password";
        }
      }
    );
    $("#download-dt-client").attr("href", require("file?name=resources/[name].[ext]!./../downloads/DeviceTouch.rar"));
    $('#switch-to-code').click(function () {
      self.loginType = 'phone';
      $('.password', '#login-form').hide();
      $('.phone', '#login-form').show();
    });
    $('#switch-to-password').click(function () {
      self.loginType = 'password';
      $('.password', '#login-form').show();
      $('.phone', '#login-form').hide();
    });

    $('#send-sms').click(function () {
      var phone = $(".mobile-code").val() + $('#home-input-phone').val().trim();
      return self.sendCodeHandler.call(self, phone, $(this));
    });
    $('#register-send-sms').click(function () {
      var phone = $('#register-input-user').val().trim();
      return self.sendCodeHandler.call(self, phone, $(this));
    });

    $('a.content-link-login', '.home-content-login-title').click(self.showLoginForm.bind(this));
    $('a.content-link-register', '.home-content-login-title').click(self.showRegisterForm.bind(this));

    $('#home-link-terms').click(self.showTerms);

    $('.phone', '#register-form').hide();
    $('.captcha', '#register-form').show();

  },

  _getMobileCode: function () {
    var mobileCode, autoLi;
    mobileCode = $('#js-select-country');
    autoLi = mobileCode.find('li');
    $('.mobile-box').click(
      function (e) {
        var e = e || event;
        e.stopPropagation();
        if ($(".mobile-trigon").attr("name") == "trigon-up") {
          $(".mobile-trigon").removeClass("mobile-trigon-up").addClass("mobile-trigon-dowm").attr("name", "trigon-down");
          mobileCode.hide();
        } else {
          $(".mobile-trigon").removeClass("mobile-trigon-dowm").addClass("mobile-trigon-up").attr("name", "trigon-up");
          mobileCode.show();
        }
      }
    )

    $(document).click(function () {
      mobileCode.hide();
      $(".mobile-trigon").removeClass("mobile-trigon-up").addClass("mobile-trigon-dowm").attr("name", "trigon-down");
    });

    autoLi.mouseover(function () {
      $(this).siblings().filter('.hover').removeClass('hover');
      $(this).addClass('hover');
    }).mouseout(function () {
      $(this).removeClass('hover');
    }).mousedown(function () {
      $(".mobile-code").val($(this).find(".li-code").html());
      mobileCode.hide();
      $(".mobile-trigon").removeClass("mobile-trigon-up").addClass("mobile-trigon-dowm").attr("name", "trigon-down");
    });
  },

  sendCodeHandler: function (phone, btn) {
    var self = this;
    var sendCodeFailedHandler = function (data) {
      btn.removeAttr("disabled");
      self.loginErrorHandler.call(self, data);
    };

    if (btn.attr("disabled") != "disabled") {
      btn.attr('disabled', 'disabled');
      self.validateAccount(phone).done(function (phone) {
        $.ajax({
          url: "/api/sms/code",
          data: {phone: phone}
        }).done(function (data) {
          if (data.result) {
            var seconds = 90;
            btn.text(seconds + ' ' + locale.get('full_seconds')).attr('disabled', 'disabled');
            var id = setInterval(function () {
              seconds--;
              if (seconds > 0) {
                btn.text(seconds + ' ' + locale.get('full_seconds'));
              } else {
                clearInterval(id);
                btn.removeAttr("disabled");
                btn.text(locale.get('send_sms_code'));
              }
            }, 1000);
          } else {
            sendCodeFailedHandler(data);
          }

        }).fail(sendCodeFailedHandler);
      }).fail(sendCodeFailedHandler);
    }
    return false;
  },

  showLoginForm: function (e) {
    var lang = localStorage.getItem("language");
    if (lang == 'en') {
      $(".login-title-slide-bar").css({"margin": "0 .3em", "width": "3.5em"});
    } else {
      $(".login-title-slide-bar").css("width", "2.4em");
    }
    $('#login-form').show();
    $('#register-form').hide();

    $(e.target).addClass('active');
    $('a.content-link-register', '.home-content-login-title').removeClass("active");
    $('.login-title-slide-bar').removeClass('right');

  },

  showRegisterForm: function (e) {
    var lang = localStorage.getItem("language");
    if (lang == 'en') {
      $(".login-title-slide-bar").css({"margin": "0 .2em", "width": "3.7em"});
    } else {
      $(".login-title-slide-bar").css("width", "2.4em");
    }
    $('#login-form').hide();
    $('#register-form').show();

    if (!this.registerCaptcha) {
      this.registerCaptcha = new Captcha({
        selector: $('.register-captcha')
      });
    }

    $(e.target).addClass('active');
    $('a.content-link-login', '.home-content-login-title').removeClass("active");
    $('.login-title-slide-bar').addClass('right');

  },
  /*邮箱自动补全功能*/
  _emailAutoComplete: function () {
    $('#home-input-user').completer({
      source: [
        "inhand.com.cn",
        "qq.com",
        "126.com",
        "163.com",
        "sina.com",
        "sohu.com",
        "gmail.com",
        "icloud.com",
        "outlook.com",
        "googlemail.com",
        "yahoo.com",
        "hotmail.com",
        "live.com",
        "msn.com",
        "verizon.net",
        "facebook.com",
        "me.com",
        "mac.com",
        "139.com",
        "189.com",
        "wo.com.cn"
      ],
      separator: '@'
    });
  },
  _renderQRcode: function () { //使用插件生成二维码的方法
    var qr = qrcode.qrcode(6, 'M');

    var host = window.location.host;

    qr.addData("http://" + host + "/DeviceNetwork/downloads/Alarm.apk");
    qr.make();
    var imgTag = qr.createImgTag(6);
    $(".alarm-app-qrcode").append(imgTag);
  },
  _locale: function () {
    locale.render();
  },
  _setAboutUsLink: function () {
    var lang = localStorage.getItem("language");
    if (lang == 'en') {
      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
    } else if (lang == 'zh_CN') {
      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhand.com.cn/");
    } else {
      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
    }
  },
  _renderHeader: function () {
    this.header = new Header({
      selector: "#common-header"
    });
  },

  _renderNav: function () {
    this.nav = new Nav({
      selector: "#common-nav",
      windowElement: "#home-content",
      current: 0
    });
  },

  _renderFooter: function () {
    this.footer = new Footer({
      selector: "#common-footer",
      contentElement: "#home-content"
    });

  },

  showTerms: function () {
    var self = this;
    require.ensure([], function () {
      var Window = require('cloud/components/window');
      var marked = require('marked');
      marked.setOptions({
        gfm: true
      });
      var language = locale.current() == 1 ? 'en' : 'zh_CN';
      var md = require('!raw?name=[name]-[hash:6].[ext]!./terms/' + language + '.md');
      require("github-markdown-css");

      self.termWindow = new Window({
        container: $('#home-content'),
        id: "term-window",
        title: locale.get('service_terms'),
        top: "center",
        left: "center",
        height: 400,
        width: 600,
        mask: true,
        drag: true,
        content: $('<div>').addClass("markdown-body").css({
          "font-size": '14px',
          "padding": "10px 20px"
        }).html(marked(md))
      });
      self.termWindow.show();
    }, 'terms');
  },

  _validator: function () {
    validator.render("#login-form", {
      promptPosition: "topLeft",
      scroll: false,
      binded: false
    });
    var self = this;
    validator.render("#register-form", {
      promptPosition: "topLeft",
      scroll: false,
      binded: false,
      onValidationComplete: function (data, status) {
        if (status) {
          self.submitRegister.call(self);
        }
      }
    });
  },
  submitRegister: function () {
    var username = $('#register-input-user').val();
    var org = $('#register-input-org-name').val();
    var password = cloud.util.md5($('#register-input-pwd-password').val());
    validator.hide('#register-input-user');
    var type = this.accountType(username);
    var self = this;

    this.validateAccount(username).done(function (username) {
      var data = {
        username: username,
        name: org,
        password: password
      };
      data[type] = username;
      if (type == "phone") {
        data.code = $('#register-input-sms-code').val();
      } else {
        data.picId = self.registerCaptcha.pictureId;
        data.varificationCode = $("#register-input-ver-custom").val();
      }

      cloud.Ajax.request({
        url: "api2/organizations?language=" + locale.current(),
        type: "POST",
        data: data,
        error: function (data) {
          if (data.error_code == 20007) {
            if (data.error.indexOf(username) > -1) {
              dialog.render({lang: "account_already_exsits"});
            } else {
              dialog.render({lang: "organization_already_exists"});
            }
          } else {
            dialog.render({lang: data.error_code});
          }
          self.registerCaptcha.refresh();
        },
        success: function (data) {
          Model.user({
            method: "login",
            data: {
              username: username,
              password: password,
              password_type: 2
            },
            param: {
              language: locale.current()
            },
            error: self.loginErrorHandler.bind(self)
          });
        }
      });
    }).fail(function () {
      dialog.render({lang: 'invalid_email_or_phone_number'});
    });

  },


  _showPasswordInput: function (focus) {
    $("#home-input-pwd-text").hide();
    $("#home-input-pwd-password").show();
    if (focus) {
      $("#home-input-pwd-password").focus();
    }
  },

  _showVercodeInput: function (focus) {
    $("#home-input-ver-default").hide();
    $("#home-input-ver-custom").show();
    if (focus) {
      $("#home-input-ver-custom").focus();
    }
  },

  _events: function () {
    var self = this;
    // 在输入框中给出提示
    $("#home-input-pwd-text").focus(function () {
      self._showPasswordInput(true);
    });

    $("#home-input-ver-default").focus(function () {
      self._showVercodeInput(true);
    });
  },

  _effects: function () {
    var self = this;
    $("#home-login-forget").bind("click", function () {
      require(["./forget_pass"], function (Forgetpass) {
        var forgetpass = new Forgetpass({
          windowElement: "#home-content"
        });
      });
    });
    /* 登录按钮点击事件 */
    $("#home-input-submit").bind("click", function () {
      self._showPasswordInput();
      self._showVercodeInput();
      var $body = $("body");
      if (validator.result("#login-form") && $body.find(".inhand-dialog").length == 0 && $body.find(".ui-window-content").length == 0) {
        self._login();
      }
      return false;
    });
  },

  loginErrorHandler: function (error) {
    this.loginCaptcha.refresh();
    var result = false;
    if (error.error_code == 21304) {
      var remainingTime = error.error.substring(error.error.indexOf("(") + 1, error.error.indexOf(")"));
      dialog.render({
        content: [{lang: 21304}, {html: "<span id='remaining-time'></span>"}, {lang: "seconds"}],
        close: function () {
          if (t) {
            clearInterval(t)
          }
        }
      });
      var $remaining = $("#remaining-time");
      $remaining.text(" " + remainingTime + " ");
      function time() {
        s = $remaining.text();
        s = parseInt(s);
        if (s <= 0) {
          clearInterval(t);
          dialog.close();
          return;
        }
        $remaining.text(" " + (s - 1) + " ");
      }

      t = setInterval(function () {
        time();
      }, 1000);
    } else if (error.error_code == 21306) {
      dialog.render({
        lang: error.error_code, buttons: [{
          lang: "ok", click: function () {
            dialog.close();
            $("#home-input-ver-custom").focus();
          }
        }]
      });
    } else if (error.error_code == 20002) {
      dialog.render({
        lang: error.error_code, buttons: [{
          lang: "ok", click: function () {
            dialog.close();
            $("#home-input-user").focus();
          }
        }]
      });
    } else if (error.error_code == 21302) {
      if (result) {
        dialog.render({
          lang: error.error_code,
          container: "#home-content-bottom-div-top",
          buttons: [{
            lang: "ok", click: function () {
              dialog.close();
              $("#home-input-user").focus();
            }
          }]
        });
      } else {
        dialog.render({
          lang: error.error_code,
          buttons: [{
            lang: "ok",
            click: function () {
              dialog.close();
              $("#home-input-user").focus();
            }
          }]
        });
      }
    } else if (error.error_code == 10017) {
      dialog.render({lang: 'please_input_valid_phone'});
    } else {
      if (result) {
        dialog.render({lang: error.error_code, container: "#home-content-bottom-div-top"});
      } else {
        dialog.render({lang: error.error_code});
      }
    }
  },

  accountType: function (email) {
    return validateEmail(email) ? "email" : "phone";
  },

  validateAccount: function (username) {
    var def = $.Deferred();
    if (username == "admin") {
      def.resolve(username);
    } else if (username.indexOf('@') != -1) {
      if (validateEmail(username)) {
        def.resolve(username);
      } else {
        def.reject();
      }
    } else {
      $.ajax({
        url: "/api/phone/validate",
        data: {
          phone: username
        }
      }).done(function (data) {
        if (data.result) {
          username = data.result;
          def.resolve(data.result);
        } else {
          def.reject(data);
        }
      }).fail(function () {
        def.reject();
      });
    }
    return def;
  },

  _login: function () {
    var self = this;
    var username;
    var password;
    var passwordType;

    if (self.loginType == 'password') {
      username = $("#home-input-user").val();
      password = $("#home-input-pwd-password").val();
      passwordType = 3;
    } else {
      username = $(".mobile-code").val() + $("#home-input-phone").val();
      password = $('#home-input-sms-code').val().trim();
      passwordType = 4;
    }

    var pictureId = self.loginCaptcha.pictureId;
    var code = $("#home-input-ver-custom").val();
    self.validateAccount(username)
      .done(function (username) {
        Model.user({
          method: "login",
          data: {
            username: username,
            password: password,
            pictureId: pictureId,
            password_type: passwordType,
            code: code
          },
          param: {
            language: locale.current()
          },
          error: self.loginErrorHandler.bind(self)
        });
      })
      .fail(self.loginErrorHandler.bind(self));

  }
});

module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/index.js
// module id = 0
// module chunks = 0